import '../../styles/components/product-drawer.scss';
import { multilingual_url } from '../utils/multilingual-url';
import '../../styles/components/price.scss';

/**
 * Product Drawer
 * Used to display a quick buy drawer or a product edit drawer
*/

class ProductDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawerTitle = this.querySelector('[data-product-title]');

    this.productDrawerContent = this.querySelector('[data-product-drawer]');

    document.addEventListener('open-product-drawer', this.openDrawer.bind(this));
  }

  async openDrawer(event) {
    const product = event.detail.product;

    this.drawerTitle.innerHTML = product.title;
    this.drawerTitle.title = product.title;

    this.productDrawerContent.innerHTML = '';
    this.productDrawerContent.classList.add('loading');
    this.classList.remove('edit', 'purchase');
    this.classList.add(event.detail.action);

    this.querySelector('details-disclosure').toggle();

    const quickAddResponse = await fetch(multilingual_url(`/products/${product.handle}?view=quick-add&variant=${event.detail.selectedVariantId}`));
    const quickAddHtml = await quickAddResponse.text();

    this.productDrawerContent.innerHTML = quickAddHtml;

    this.productDrawerContent.classList.remove('loading');
    this.initializeForm(event);
  }

  initializeForm(event) {
    const form = this.productDrawerContent.querySelector('product-main-form');

    if (event.detail.action === 'edit') {
      form.keyToRemove = event.detail.itemKey;
      form.querySelector('[name="quantity"]').value = event.detail.itemQuantity;
      this.querySelector('details-disclosure').skipScrollReset = true; // Ensures releaseScroll() is not called when closing the drawer
      form.submitButtonText.innerHTML = theme.strings.product.saveChanges;
    }

    form.addEventListener('submit', () => {
      this.querySelector('details-disclosure').close();
    });

    // Initialize the image swiper to show the selected variant's image
    if (event.detail.selectedVariantId) {
      this.initializeVariantImage(form, event.detail.selectedVariantId);
    }
  }

  initializeVariantImage(form, selectedVariantId) {
    // Parse variant ID to number for comparison (form value is string, product variant ID is number)
    const variantId = parseInt(selectedVariantId, 10);
    
    // Wait for the swiper to be fully initialized
    const checkSwiper = () => {
      if (form.imageSwiper?.swiper && form.product) {
        const selectedVariant = form.product.variants.find(v => v.id === variantId);
        if (selectedVariant && typeof form.updateSlideImages === 'function') {
          form.updateSlideImages(selectedVariant);
        }
      } else {
        // If swiper not ready yet, check again in 50ms
        setTimeout(checkSwiper, 50);
      }
    };
    
    // Start checking after a small delay to ensure DOM is ready
    setTimeout(checkSwiper, 100);
  }
}

try {
  customElements.define('product-drawer', ProductDrawer);
}
catch(e) {}
